
interface DividerProps {
  style?: React.CSSProperties;
}

export default function Divider({ style = {} }: DividerProps) {
  return (
    <div
      className="w-full h-[10px] bg-[#EAEAEA]"
      style={{
        ...style,
        width: '100vw',
        marginLeft: '-20px',
        marginRight: '-20px',
      }}
    />
  );
}

